module.exports = __webpack_public_path__ + "static/media/hdfs.c75209ee.png";